import { useEffect, useState } from "react";
import RoundItem from "./components/Round";
import { formatNumber } from "../../services/utility/utils";
import axios from "axios";
import "./styles.scss";
import { useTheme } from "../../hook/useThemes";
import { CircularProgress } from "@mui/material";
import { ReactComponent as IconUp } from "../../assets/images/icon-up.svg";
import { ReactComponent as IconDown } from "../../assets/images/icon-down.svg";

const { REACT_APP_URL_HXROAPI } = process.env;

export default function FormPage() {
  const [form, setForm] = useState<any>();
  const [latestResult, setLatestResult] = useState([]);
  const { lang, fixed_odds , seriesID} = useTheme();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!seriesID) {
      window.location.reload();
      return;
    }
    axios
      .get(`${REACT_APP_URL_HXROAPI}/stats/result/${seriesID}`)
      .then(({ data }) => {
        setForm([
          { title: lang?.last0_rounds || "Last 10 rounds", ...data.last10 },
          {
            title: lang?.last_hour || "Last Hour (60 rounds)",
            ...data.last_hour,
          },
          {
            title: lang?.last_day || "Last Day (1440 rounds)",
            ...data.last_day,
          },
        ]);
        setLatestResult(data.latest_result);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [seriesID]);

  const handleRenderIcon = (type: string) => {
    if (type === "up") {
      return <IconUp />;
    }
    return <IconDown />;
  };

  return (
    <div className="wrapper-form-page">
      <div className="container wrapper-form-content">
        <p className="title-form-content">{lang?.results || "Results"}</p>

        {loading && (
          <div className="wrap-loading">
            <p>{lang?.loading || "Loading result"}</p>
            <CircularProgress
              size={24}
              className="circular-progress"
              style={{
                color: "#B3BECE",
              }}
            />
          </div>
        )}

        {!!latestResult?.length && (
          <>
            <p className="title-latest-result animate__animated animate__fadeInDown">
              {lang?.latest_results || "Winning odds from last rounds "}
            </p>
            <div className="wrapper-content-latest-result animate__animated animate__fadeInDown">
              <div className={`content-latest-result`}>
                {latestResult.map((item: any, index) => {
                  return (
                    <div
                      className={`content-latest-result-item ${item.side}`}
                      key={index}
                    >
                      <p className="content-label">
                        {fixed_odds
                          ? handleRenderIcon(item.side)
                          : formatNumber(item.odd, 2)}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}

        {!!form?.length && (
          <div className="wrapper-content-rounds">
            {(form || []).map((item: any, index) => {
              return <RoundItem {...item} key={index} index={index} />;
            })}
          </div>
        )}

        {/* <div className="wrapper-content-bottom">
          <p className="title-content-bottom">Did you know?</p>
          <div className="content-bottom">
            <div className="content-bottom-item">
              <p className="content-value">{formatNumber(stats.up_perc)}%</p>
              <p className="content-label">Participants bet Up</p>
            </div>
            <div className="content-bottom-item">
              <p className="content-value">{formatNumber(stats.count_winning)}</p>
              <p className="content-label">Participants won </p>
            </div>
            <div className="content-bottom-item">
              <p className="content-value">{formatNumber(stats.total_gain)}</p>
              <p className="content-label">Total gain with Up or Down game</p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
